import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Ricarica le richieste dell'utente fresche dal DB (single source of truth per lo stato).
// Usato all'atterraggio sul profilo (e al resume dell'app nativa) così lo stato "accepted"
// diventa visibile senza attendere un refresh completo dell'app.
export const fetchUserRequests = createAsyncThunk(
    'user/fetchUserRequests',
    async (_, { rejectWithValue }) => {
        const token = localStorage.getItem('ticino-wild-token');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/requests/my-requests`;
        try {
            const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
            if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                return rejectWithValue(err.message || 'Errore nel caricamento delle richieste.');
            }
            const data = await response.json();
            return data.payload;
        } catch (e) {
            return rejectWithValue('Errore di rete nel caricamento delle richieste.');
        }
    }
);

const initialState = {
    isLoading: false,
    isLogged: false,
    id: null,
    user: null,
    level: null,
    isUserPurchaseAvailable: null,
    favourites: [],
    requests: [],
    requestsStatus: 'idle', // idle | loading | succeeded | failed
    requestsError: null,
    isCheckingAuth: true
}
const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        getLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        getLogged: (state, action) => {
            state.isLogged = true;
            state.id = action.payload.id;
            state.user = action.payload.name;
            state.level = action.payload.level;
            state.isUserPurchaseAvailable = action.payload.isUserPurchaseAvailable;
            state.isUserShopOrderAvailable = action.payload.isUserShopOrderAvailable;
            state.favourites = action.payload.favourites;
            state.requests = action.payload.requests;
            state.isLoading = false;
            state.isCheckingAuth = false;
        },
        getUnlogged: () => {
            return { ...initialState, isCheckingAuth: false }
        },
        setFavourite: (state, action) => {
            const { activityId, isFavourite } = action.payload
            if (isFavourite) {
                if (!state.favourites.some(f => f.activityId === activityId)) {
                    state.favourites.push({ activityId, isDone: false, doneAt: null })
                }
            } else {
                state.favourites = state.favourites.filter(f => f.activityId !== activityId);
            }
        },
        toggleFavouriteDone: (state, action) => {
            const { activityId, isDone, doneAt } = action.payload;
            const fav = state.favourites.find(f => f.activityId === activityId);
            if (fav) {
                fav.isDone = isDone;
                fav.doneAt = doneAt ?? null;
            }
        },
        setRequestStatus: (state, action) => {
            const { requestId, status } = action.payload;
            state.requests = state.requests.map((r) => {
                const id = r._id != null ? String(r._id) : null;
                if (id === String(requestId)) {
                    return { ...r, status };
                }
                return r;
            });
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserRequests.pending, (state) => {
                state.requestsStatus = 'loading';
                state.requestsError = null;
            })
            .addCase(fetchUserRequests.fulfilled, (state, action) => {
                state.requestsStatus = 'succeeded';
                state.requests = action.payload;
            })
            .addCase(fetchUserRequests.rejected, (state, action) => {
                state.requestsStatus = 'failed';
                state.requestsError = action.payload || 'Errore nel caricamento delle richieste.';
            });
    }
})

export const { getLogged, getUnlogged, getLoading, setFavourite, toggleFavouriteDone, setRequestStatus } = userSlice.actions;
export default userSlice.reducer;